<template>
    <div class="animated-dots">
      <lottie
        :options="defaultOptions"
        :height="34"
        :width="35"
        v-on:animCreated="handleAnimation"
      />
    </div>
</template>
  
  <script>
  import Lottie from "vue-lottie" ;
  import * as animationData from "../assets/dots.json";
  export default {
    name: "Dots",
    data() {
      return {
        defaultOptions: { animationData: animationData },
        animationSpeed: 0.5
      };
    },
    methods: {
      handleAnimation: function(anim) {
        this.anim = anim;
      },
  
      stop: function() {
        this.anim.stop();
      },
  
      play: function() {
        this.anim.play();
      },
  
      pause: function() {
        this.anim.pause();
      },
  
      onSpeedChange: function() {
        this.anim.setSpeed(this.animationSpeed);
      }
    }
  };
  </script>
  
  <style scoped>
  .animated-dots{
    align-items: center;
    display: flex;
    justify-content: flex-start;
  }
  </style>


// WEBPACK FOOTER //
// Dots.vue?5f295728